// extracted by mini-css-extract-plugin
module.exports = {"nouns":"styles_nouns__j3_MC"};